import { render, staticRenderFns } from "./PermissionGroup.vue?vue&type=template&id=286f40ee&scoped=true&lang=pug&"
import script from "./PermissionGroup.vue?vue&type=script&lang=js&"
export * from "./PermissionGroup.vue?vue&type=script&lang=js&"
import style0 from "./PermissionGroup.vue?vue&type=style&index=0&id=286f40ee&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286f40ee",
  null
  
)

export default component.exports